// actions.js

import * as ActionTypes from './actionsTypes';

export const validateLinkedinAccessTokenRequest = () => ({
  type: ActionTypes.VALIDATE_ACCESS_TOKEN_REQUEST
});

export const validateLinkedinAccessTokenSuccess = (data) => ({
  type: ActionTypes.VALIDATE_ACCESS_TOKEN_SUCCESS,
  data,
});

export const validateLinkedinAccessTokenFailure = (error) => ({
  type: ActionTypes.VALIDATE_ACCESS_TOKEN_FAILURE,
  error,
});

export const saveLinkedinCompanyRequest = (linkedinCompanyId) => ({
  type: ActionTypes.SAVE_LINKEDIN_COMPANY_REQUEST,
  linkedinCompanyId,
});

export const saveLinkedinCompanySuccess = (message) => ({
  type: ActionTypes.SAVE_LINKEDIN_COMPANY_SUCCESS,
  message,
});

export const saveLinkedinCompanyFailure = (error) => ({
  type: ActionTypes.SAVE_LINKEDIN_COMPANY_FAILURE,
  error,
});